angular.module('leanlaw').filter("reportSettingFilter", [function () {
  return function (accounts, filter) {
    return accounts && accounts.filter(a => !filter || a.account && (a.account.role === 'lead' || a.account.role === 'principal'));
  };
}]);